import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { getBooleanLabel } from 'src/app/_helpers/utils';
import { BusinessRcCompanyGenericCoverage } from 'src/app/_services/types/business-insurances.types';

@Component({
  selector: 'app-generic-coverage-display',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './generic-coverage-display.component.html',
})
export class GenericRcCompanyCoverageDisplayComponent {
  @Input() coverage: BusinessRcCompanyGenericCoverage | null | undefined;

  @Input() insuredSumLabel: string = $localize`Somme d'assurance`;

  @Input() deductibleLabel: string = $localize`Franchise`;

  getBooleanLabel = getBooleanLabel;
}
